import tmhRequest from '@/config/tmhRequest'

export default {
    searchMyCard: function (data) {
        return tmhRequest({
            url: '/customer/tmh/mycard/searchmycard',
            method: 'post',
            params: data,
        })
    },
    searchListMyCard: function (data) {
        return tmhRequest({
            url: '/customer/tmh/mycard/searchlistmycard',
            method: 'post',
            params: data,
        })
    },


    addMyCard : function(data){
        return tmhRequest({
            url: '/customer/tmh/mycard/addmycard',
            method: 'post',
            data: data,
        })
    },

    upgradeMyCard : function(data){
        return tmhRequest({
            url: '/customer/tmh/mycard/upgrademycard',
            method: 'post',
            params: data,
        })
    },

    editMyCardStore : function(data){
        return tmhRequest({
            url: '/customer/tmh/mycard/editmycardstore',
            method: 'post',
            params: data,
        })
    },

    editMyCardCardNumber : function(data){
        return tmhRequest({
            url: '/customer/tmh/mycard/editmycardcardnumber',
            method: 'post',
            params: data,
        })
    },

    resetTransferExpiredMyCard: function (data) {
        return tmhRequest({
            url: '/customer/tmh/mycard/resettransferexpiredmycard',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/customer/mycard.js